module.exports = __webpack_public_path__ + "static/media/Untitled.d057d6eb.png";